module.exports = __webpack_public_path__ + "img/1.72f938ff.svg";